// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDefaultPageSize, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import * as cartSelectors from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    getCurrentPromotionsDataView,
    getDiscountTotal,
    getOrderPromotions,
    getPromotionsDataView,
    getShippingPromotions,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import ArrowBackward from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import { boxStyles } from "@store/Themes/common/mixins/box";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import closeMinicartDrawer from "@store/Framework/Store/Store/Components/MinicartDrawer/Handlers/closeMinicartDrawer";
import CartTotalDisplay, { CartTotalDisplayStyles } from "@store/Overrides/Components/CartTotalDisplay";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useCurrentCartState } from "@toolkit/Framework/Store/Data/Carts/CartsHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

function CartLines(props: any) {
    return createWidgetElement("Cart/CartLines", {
        ...props,
        forAddToCartModal: false,
        forMiniCart: true,
    });
}

function ProductCarousel() {
    return createWidgetElement("Common/ProductCarousel", {
        fields: {
            titleAlignment: "center",
            carouselType: "crossSells",
            maxNumberOfColumns: 2,
            widgetPosition: 1,
            showDots: true,
            showTextBadges: true,
            showImage: true,
            showTitle: true,
            showBrandName: true,
            showPartNumbers: true,
            showAvailability: true,
            showPrice: true,
            showAddToCart: true,
            showAddToList: true,
            maximumNumberOfTextBadges: "4",
            inModal: true,
        },
    });
}

const mapStateToProps = (state: ApplicationState) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const promotionsDataView = cartId ? getPromotionsDataView(state, cartId) : getCurrentPromotionsDataView(state);
    let orderPromotions;
    let shippingPromotions;
    let discountTotal;
    if (promotionsDataView.value) {
        orderPromotions = getOrderPromotions(promotionsDataView.value);
        shippingPromotions = getShippingPromotions(promotionsDataView.value);
        discountTotal = getDiscountTotal(promotionsDataView.value);
    }
    const isCartLoading = cartState.isLoading;
    const {
        cartSettings: { showTaxAndShipping },
    } = getSettingsCollection(state);

    return {
        isLoading: isCartLoading,
        orderPromotions,
        shippingPromotions,
        showTaxAndShipping,
        discountTotal,
        cartState,
        defaultPageSize: getDefaultPageSize(state),
        settingsCollection: getSettingsCollection(state),
        isMinicartOpen: state.store.components.minicartDrawer.isOpen,
    };
};
const mapDispatchToProps = {
    closeMinicartDrawer,
};

type Props = HasHistory & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface MinicartDrawerStyles {
    drawer?: DrawerPresentationProps;
    proceedToCartButton?: ButtonPresentationProps;
    continueToShopButton?: LinkPresentationProps;
    cartTotal?: CartTotalDisplayStyles;
    cartTotalWrapper?: InjectableCss;
}

export const MinicartDrawerStyles: MinicartDrawerStyles = {
    drawer: {
        position: "right",
        size: 800,
        enableClickThrough: true,
        cssOverrides: {
            scrim: css`
                overflow: visible;
                transition: none;
                z-index: 1291;
            `,
            drawerContainer: css``,
            drawerBody: css`
                background: ${getColor("common.background")};
                padding: ${pxToRem(0, 25)};

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                max-width: 100%;
                            `,
                            css`
                                max-width: 100%;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
            drawerTitle: css`
                color: ${getColor("text")};
                > span {
                    ${({ theme }) => `
                        padding:0;
                        font-size: ${theme.design.typography.size.large};
                        font-weight: ${theme.design.typography.weight.light};
                    `}
                }
                background: ${getColor("common.background")};
                text-align: left;
                justify-content: flex-start;
            `,
            drawerContent: css`
                margin-top: ${pxToRem(-2)};
                overflow-y: auto;
                overflow-x: hidden;
            `,
            titleButton: css`
                background: ${getColor("common.background")};
                color: ${getColor("text.main")};
                border: 0;
                padding: ${pxToRem(13)};

                svg {
                    color: ${getColor("text.main")};
                }
            `,
        },
        closeButtonProps: {
            buttonType: "outline",
        },
    },
    proceedToCartButton: {
        variant: "primary",
        sizeVariant: "large",
        css: css`
            width: 100%;
            text-transform: uppercase;
        `,
    },
    continueToShopButton: {
        color: "text.link",
        css: css`
            -webkit-flex: 1 1 auto;
            -ms-flex: 1 1 auto;
            flex: 1 1 auto;
            ${linkActionStyles()}
        `,
        icon: { iconProps: { src: ArrowBackward } },
    },
    cartTotal: {
        wrapper: {
            css: css`
                display: block;
                width: 100%;
                box-shadow: none;
                padding: 0;
                padding-bottom: 0.8em;
                margin-bottom: 1em;
                border-bottom: 1px solid ${getColor("common.border")};
            `,
        },
    },
    cartTotalWrapper: {
        css: css`
            ${boxStyles(pxToRemArray([20]))}
            margin: 1em;
            padding-bottom: 1em;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
};

const styles = MinicartDrawerStyles;

const MinicartDrawer = ({
    history,
    cartState,
    showTaxAndShipping,
    isLoading,
    orderPromotions,
    shippingPromotions,
    discountTotal,
    isMinicartOpen,
    closeMinicartDrawer,
}: Props) => {
    const cartPageLink = usePageLinkByPageType(constants.pageType.cart);
    const { value: cart } = usePersistentDataView(useCurrentCartState());
    const isCartEmpty = cartSelectors.isCartEmpty(cart);
    const handleProceedToCart = () => {
        if (cartPageLink) {
            history.push(cartPageLink.url);
        }
    };

    const handleClose = () => {
        closeMinicartDrawer();
    };

    return (
        <Drawer
            draggable
            position="right"
            isOpen={isMinicartOpen}
            handleClose={() => {
                /* Add a delay to allow form state changes to fully process and prevent visual flicker */
                setTimeout(() => {
                    handleClose();
                }, 50);
            }}
            headline={
                <Link {...styles.continueToShopButton} onClick={handleClose}>
                    {translate("Continue Shopping")}
                </Link>
            }
            {...styles.drawer}
        >
            {isMinicartOpen && !isCartEmpty && (
                <>
                    <StyledWrapper {...styles.cartTotalWrapper}>
                        <CartTotalDisplay
                            showTaxAndShipping={showTaxAndShipping}
                            extendedStyles={styles.cartTotal}
                            isLoading={isLoading}
                            isCartEmpty={isCartEmpty}
                            cart={cart}
                            orderPromotions={orderPromotions}
                            shippingPromotions={shippingPromotions}
                            discountTotal={discountTotal}
                            showCSToggle={false}
                        />
                        <Button
                            {...styles.proceedToCartButton}
                            onClick={() => {
                                handleClose();
                                handleProceedToCart();
                            }}
                        >
                            {translate("Proceed to cart")}
                        </Button>
                    </StyledWrapper>
                    {cartState.value && <CartLines returnedCartLine={cartState.value.cartLines} />}
                    <ProductCarousel />
                </>
            )}
        </Drawer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(MinicartDrawer));
